import { useState } from "react";
import classnames from "classnames";

import ChevronIcon from "components/Icons/ChevronIcon";

type Link = {
  title: string;
  url: string;
};

type Props = {
  title: string;
  id: string;
  links: Link[];
};

function Accordion({ title, id, links }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = (e: React.KeyboardEvent | React.MouseEvent) => {
    if ((e as React.KeyboardEvent)?.type === "keypress") {
      return null;
    }
    setIsOpen(!isOpen);
  };

  return (
    <section className="px-lg">
      <button
        onClick={toggleOpen}
        data-testid={`accordion-control-${id}`}
        onKeyPress={toggleOpen}
        className="flex font-extrabold items-center justify-between py-lg text-xs uppercase w-full"
      >
        <span>{title}</span>
        <ChevronIcon
          width="24"
          height="24"
          direction={isOpen ? "down" : "up"}
        />
      </button>
      <ul
        data-testid={`accordion-list-${id}`}
        className={classnames("font-medium text-sm text-green font-bold", {
          hidden: !isOpen,
        })}
      >
        {links.map((link) => (
          <li key={link.title} data-testid={link.title} className="py-sm">
            <a href={link.url}>{link.title}</a>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Accordion;
